import api from "./api"
import store from "../store/index"

export async function getCustomerInvoiceAddress() {
  const requestData = await api.get(
    `/api/v1/customer/${store.state.customerID}/invoiceaddress`,
    {
      params: {
        customerID: store.getters.customerID,
      },
    }
  )

  return requestData.data
}

export async function getCustomerShipmentAddresses({ customerID }) {
  const requestData = await api.get(
    `/api/v1/customer/${customerID}/shipmentaddresses`,
    {
      params: {
        customerID: store.getters.customerID,
      },
    }
  )

  return requestData.data
}
